export { handleShare } from './handle-share';
